const UPPER = "ABCDEFGHJKLMNPQRSTUVWXYZ";
const LOWER = "abcdefghijkmnopqrstuvwxyz";
const DIGITS = "23456789";
const SPECIAL = "!@#$%^&*()_+-=[]{};:,.?";

const pickRandomChar = (chars) => {
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    const array = new Uint32Array(1);
    crypto.getRandomValues(array);
    return chars[array[0] % chars.length];
  }

  return chars[Math.floor(Math.random() * chars.length)];
};

const shuffle = (items) => {
  const result = [...items];

  for (let i = result.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }

  return result;
};

export const generateStrongPassword = (length = 16) => {
  const finalLength = Math.max(8, length);
  const all = `${UPPER}${LOWER}${DIGITS}${SPECIAL}`;

  const chars = [
    pickRandomChar(UPPER),
    pickRandomChar(LOWER),
    pickRandomChar(DIGITS),
    pickRandomChar(SPECIAL),
  ];

  while (chars.length < finalLength) {
    chars.push(pickRandomChar(all));
  }

  return shuffle(chars).join("");
};